export const SCHEDULING_CONSTANTS = {
  HEADER: $localize`Scheduling`,
  REQUEST_NUMBER: $localize`Request/Shipper No.`,
  ORDER_TYPE: $localize`Order Type`,
  CSTC_SITE_NAME: $localize`CSTC Site Name`,
  READY_TIME: $localize`Ready Time`,
  ORDER_DATE: $localize`Order Date`,
  SERVICE_CENTER_SLIC: $localize`Service Center SLIC`,
  CSTC_OPERATOR: $localize`CSTC Operator`,
  SERVICE_DATE: $localize`Service Date`,
  PREFERRED_CUSTOMER: $localize`Preferred Customer`,
  CSTC_SITE_PHONE: $localize`CSTC Site Phone`,
  COMMIT_TIME: $localize`Commit Time`,
  SERVICE_TYPE: $localize`Service Type`,
  PACKAGE_TYPE: $localize`Package Type`,
  SHIP_CHARGE: $localize`Ship/PU Charge`,
  PICK_UP_AMT: $localize`Pick Up Amt`,
  CLOSING_TIME: $localize`Closing Time`,
  SHIPPER_NUMBER: $localize`Shipper Number`,
  PACKAGE_WEIGHT: $localize`Package Weight`,
  VAT_PORTION: $localize`Vat Portion`,
  PICKUP_NUMBER: $localize`Pickup Number`,
  OVER_WEIGHT: $localize`Over Weight`,
  DRIVER_INSTRUCTIONS: $localize`Driver Instructions`,
};

export const SCHEDULED_PICKUPS = {
  READY_TIME: 'readyTime',
  COMMIT_TIME: 'commitTime',
  CLOSING_TIME: 'closingTime',
};
